import React, {useState,useEffect,useRef} from 'react'
import { Formik, Field } from 'formik'
import { Table,Button,Icon,Form,Select,Input,List,Image,Label,TextArea } from 'semantic-ui-react'
import moment from 'moment'
import DatePicker from "react-datepicker"
import Cleave from 'cleave.js/react'

import Paginations from '../../../config/pagination'
import EntryList from '../../../config/entries'
import {WindowReload, WindowURLAdmin, WindowLocationAdmin} from '../../../config/settings'
import Alertmessage from '../../../config/alert'
import axios from 'axios'
import renderHTML from 'react-render-html'
import {insertvalidations} from './validate'


export default function TradingSellComponent(props) {

	const [alert,setalert] = useState(false);
	const [Alertcontent,setAlertcontent] = useState({});
	function Alertclose(){setalert(false);}
	function Alertconfirm(data){if(data.confirm==true){setalert(false);}}
	function Alertdelete(data){
		if(data.delete==true){
			DeleteRecord(data.id);
		}
	}
	function DeleteConfirmation(id){
		setAlertcontent({intent:'delete',settings:{id:id,centered:false,icon:'warning',title:'Delete Confirmation!',html:'This process is not ireversible. Once you continue the process, the record will be deleted on the database.',footer:'none'}});
		setalert(true);
	}


	/* ------------------------------------------
		List with paginations
	---------------------------------------------*/
	const [search, setsearch]  = useState({
			account:'',
	});

	const [list, setlist] = useState([]);
	const [pagenumber, setpagenumber] = useState(1);
	const [totaldata, settotaldata] = useState(0);
	const [entry, setentry] = useState(0);
	const [entrytype, setentrytype] = useState('');

	const [paginations, setpaginations] = useState({
			paginations:[{
			listnav:[],
			pageinfo:'',
			limit_page:'',
			total_page:'',
			total_records:'',
			current_page:'',
			startPage:'',
			endPage:'',
			ellipseLeft:'',
			ellipseRight:'',
			}]
	});

	function pagenumberfunction(page){
				TableList(page,search);
		}
		function listreload(){
				TableList(pagenumber,search);
		}
		function searchProcess(){
			  TableList(pagenumber,search);
		}
		function TableList(page,searchstr){

			 setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Loading',html:"This won't take long, please wait...",footer:'none'}});
			 setalert(true);

				let formData = new FormData();
				formData.append('type','list');
				formData.append('search',JSON.stringify(searchstr));
				formData.append('page',page);
				axios.post('/admin/tradingsell/http.php',formData)
				.then(function (response) {
						let obj = response.data;
						setentry(obj.entries.val);
						setentrytype(obj.entries.type);
						setlist(obj.listtable);
						setpaginations(obj.paginations);
						settotaldata(obj.paginations.paginations.total_records);
						setalert(false);

				})
				.catch(function (error){
					setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
					setalert(false);
				});
		}

		function handleSubmitForm(values, props){
			TableList(pagenumber,values);
	  }

	 /* ------------------------------------------
			List with paginations end
		---------------------------------------------*/

	/*-------------------------------------------------------------------------
	 Forms: Adding and Updating
	--------------------------------------------------------------------------*/
	const [state,setstate] = useState({
		id:'',
		account:'',
		transaction_number:'',
		sell_date:'',
		ticker_symbol:'',
		price_unit:'',
		quantity:'',
		sell_amount:'',
		status:'',
		submit:'add',
	});
	function handleSubmitForm(values, props){

		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Processing',html:"This won't take long, please wait...",footer:'none'}});
		setalert(true);

		let value = {
			id:values.id,
			account:values.account,
			sell_date:values.sell_date!=''?moment(new Date(values.sell_date)).format('YYYY-MM-DD'):'',
			transaction_number:values.transaction_number,
			ticker_symbol:values.ticker_symbol,
			price_unit:values.price_unit,
			quantity:values.quantity,
			sell_amount:values.sell_amount,
			status:values.status,
		}

		let formData = new FormData();
		formData.append('type',values.submit);
		formData.append('info',JSON.stringify(value));
		axios.post('/admin/tradingsell/http.php',formData)
		.then(function (response) {

			let obj = response.data;

			if(obj=='success'){
				setAlertcontent({intent:'alert',settings:{centered:false,icon:'success',title:'Congratulations',html:"Data successfully saved."}});
				setalert(true);
				setTimeout(function() {WindowLocationAdmin('/tradingsell');},2000);
				return false;
			}

			if(obj=='error'){
				setAlertcontent({intent:'alert',settings:{centered:false,icon:'error',title:'Saving Error!',html:"Data not successfully saved. Please try again later.",footer:'yes'}});
				setalert(true);
				setTimeout(function() {WindowReload();},2000);
				return false;
			}

			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Input Error!',html:"Please correct the input errors.",footer:'yes'}});
			setalert(true);
			setTimeout(function() {setalert(false);},2000);
			Object.keys(obj).forEach(function(key) {
        props.setErrors(obj);
      });

		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
			setalert(true);
			setTimeout(function() {WindowReload();},2000);
		});
	}



	/*-------------------------------------
	 Delete
	--------------------------------------*/
	function DeleteRecord(id){

		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Deleting',html:"Deleting record is on process, please wait...",footer:'none'}});
		setalert(true);

		let formData = new FormData();
		formData.append('type','delete');
		formData.append('id',id);
		axios.post('/admin/tradingsell/http.php',formData)
		.then(function (response) {
				let obj = response.data;
				if(obj=='success'){
					setAlertcontent({intent:'alert',settings:{centered:false,icon:'success',title:'Congratulations',html:"Record successfully deleted."}});
					setTimeout(function() {
						WindowLocationAdmin('/tradingsell');
						setalert(false);
					},2000);
				}else{
					setAlertcontent({intent:'alert',settings:{centered:false,icon:'error',title:'Delete Failed',html:"Record not successfully deleted."}});
					setTimeout(function() {setalert(false);},2000);
				}
		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error',html:"Problem connecting to the server."}});
			setalert(true);
			setTimeout(function() {setalert(false);},2000);
		});
}


	/*-------------------------------------
	 Updating Form
	--------------------------------------*/
	function DetailsData(id){
		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Processing',html:"This won't take long, please wait...",footer:'none'}});
		setalert(true);
		let formData = new FormData();
		formData.append('type','details');
		formData.append('id',id);
		axios.post('/admin/tradingsell/http.php',formData)
		.then(function (response) {
				let obj = response.data;
				if(obj==0){
					WindowLocationAdmin('/tradingsell');
					return false;
				}else{
					setstate({
						...state,
						id:obj.id,
						account:obj.account,
						transaction_number:obj.transaction_number,
						sell_date:obj.sell_date!=''?moment(new Date(obj.sell_date)).format('MM/DD/YYYY'):'',
						ticker_symbol:obj.ticker_symbol,
						price_unit:obj.price_unit,
						quantity:obj.quantity,
						sell_amount:obj.sell_amount,
						status:obj.status,
						submit:'update',
					});
					setalert(false);
					return false;
				}

		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error',html:"Problem connecting to the server."}});
			setalert(true);
			setTimeout(function() {setalert(false);},2000);
		});
	}


	/*-------------------------------------
	 Selection Quries
	--------------------------------------*/
	const [AccountCustomer, setAccountCustomer] = useState([]);



	function SelectionQuries(){
		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Processing',html:"This won't take long, please wait...",footer:'none'}});
		setalert(true);
		let formData = new FormData();
		formData.append('type','trading_selection');
		axios.post('/admin/tradingsell/http.php',formData)
		.then(function (response) {
				let obj = response.data;
				setAccountCustomer(obj.AccountCustomer);
		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error',html:"Problem connecting to the server."}});
			setalert(true);
			setTimeout(function() {setalert(false);},2000);
		});
	}


	useEffect(()=>{
		TableList(pagenumber,search);
		SelectionQuries();
		if(props.match.params.id){
			DetailsData(props.match.params.id);
		}
	},[]);


	return (
		<React.Fragment>
      <div className="page-wrapper">
				{alert&&<Alertmessage close={Alertclose} data={Alertcontent} confirm={Alertconfirm} delete={Alertdelete}/>}
				<Form>
					<Formik
					  enableReinitialize
						initialValues={state}
						validationSchema={insertvalidations}
						onSubmit={handleSubmitForm}
						render={formProps => {
						const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, touched, setFieldValue } = formProps

						const CustomDate = ({ value, onClick }) => (
							<Input iconPosition='left' onClick={onClick} value={values.sell_date}><Icon name='calendar alternate' /><input /></Input>
						);


						return(
			         <div className="panel hasbottom">
			            <div className="panel-header">Trading Sell</div>
			            <div className="panel-body">


									 <div className="formtwo-wrapper">
									 		<div>

											<div className="inlinformtwo">
 										 		<div><label>Select Client/Member</label></div>
 												<div>
													<Form.Group widths="equal">
														<Field name="account">
															{({ field, form }) => (
																	<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																		<Select selectOnBlur={false}
																				{...field}
																				options={AccountCustomer}
																				onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																		{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																	</Form.Field>
															)}
														</Field>
													</Form.Group>
 												</div>
 										 </div>{/*.inlinform*/}

										 <div className="inlinformtwo">
 											<div><label>Sell Transaction Number</label></div>
 											<div>
 											<Form.Group widths="equal">
 												<Field name="transaction_number">
 														{({ field, form }) => (
 														<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
 															<Input {...field} onChange={handleChange}/>
 															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
 														</Form.Field>
 														)}
 												</Field>
 											</Form.Group>
 											</div>
 									 </div>{/*.inlinform*/}

										 <div className="inlinformtwo">
											 <div><label>Sell Date</label></div>
											 <div>
												 <Form.Group widths="equal">
													<Field name="sell_date">
															{({ field, form }) => (
															<Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																<DatePicker
																		showYearDropdown
																		yearDropdownItemNumber={100}
																		scrollableYearDropdown
																		showMonthDropdown
																		dropdownMode="select"
																		selected={values.sell_date!=''?new Date(values.sell_date):null}
																		onChange={date => {
																			 var date_selected 	= moment(new Date(date)).format('MM/DD/YYYY');
																			 setFieldValue(field.name,date_selected);
																		}}
																		customInput={<CustomDate />}/>
																{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
															</Form.Field>
															)}
													</Field>
												</Form.Group>
											 </div>
										</div>{/*.inlinform*/}


										<div className="inlinformtwo">
											<div><label>Product/Ticker Symbol	</label></div>
											<div>
											<Form.Group widths="equal">
												<Field name="ticker_symbol">
														{({ field, form }) => (
														<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
															<Input {...field} onChange={handleChange}/>
															{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
														</Form.Field>
														)}
												</Field>
											</Form.Group>
											</div>
									 </div>{/*.inlinform*/}

									 <div className="inlinformtwo">
										 <div><label>Sell Price per Unit	</label></div>
										 <div>
										 <Form.Group widths="equal">
											 <Field name="price_unit">
													 {({ field, form }) => (
													 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
														 <Input {...field} onChange={handleChange}/>
														 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
													 </Form.Field>
													 )}
											 </Field>
										 </Form.Group>
										 </div>
									</div>{/*.inlinform*/}

									<div className="inlinformtwo">
										<div><label>Quantity</label></div>
										<div>
										<Form.Group widths="equal">
											<Field name="quantity">
													{({ field, form }) => (
													<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
														<Input {...field} onChange={handleChange}/>
														{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
													</Form.Field>
													)}
											</Field>
										</Form.Group>
										</div>
								 </div>{/*.inlinform*/}


							 <div className="inlinformtwo">
								 <div><label>Total Sell Amount</label></div>
								 <div>
								 <Form.Group widths="equal">
									 <Field name="sell_amount">
											 {({ field, form }) => (
											 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
												 <Input {...field} onChange={handleChange}/>
												 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
											 </Form.Field>
											 )}
									 </Field>
								 </Form.Group>
								 </div>
							</div>{/*.inlinform*/}

							<div className="inlinformtwo">
								<div><label>Status</label></div>
								<div>
								<Form.Group widths="equal">
									<Field name="status">
											{({ field, form }) => (
											<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
												<Input {...field} onChange={handleChange}/>
												{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
											</Form.Field>
											)}
									</Field>
								</Form.Group>
								</div>
						 </div>{/*.inlinform*/}

							</div>{/*.left column*/}


							<div></div>{/*.right column*/}

							</div>{/*.end wrapper*/}


									</div>{/*.panel-body*/}
			            <div className="panel-footer">
									    {values.submit=='update'&&<Button className='red' size='large' icon='close' content='Cancel' href={WindowURLAdmin('/tradingsell')}/>}
											<Button className='secondary' size='large' icon="save" content={values.submit=='update'?'UPDATE':'SAVE'} onClick={handleSubmit}/>
									</div>
			         </div>

						 )}}/>
					</Form>

					<div className="panel">
						 <div className="panel-header">Trading Record-Sell</div>
						 <div className="panel-body">
						 	 <div className="table-responsive">
								 <Table celled singleLine unstackable>
									 <Table.Header>
										 <Table.Row>
										 	 <Table.HeaderCell>Delete</Table.HeaderCell>
										 	 <Table.HeaderCell>Edit</Table.HeaderCell>
											 <Table.HeaderCell>Account</Table.HeaderCell>
											 <Table.HeaderCell>Sell Transaction Number	</Table.HeaderCell>
											 <Table.HeaderCell>Sell Date</Table.HeaderCell>
											 <Table.HeaderCell>Product/Ticker Symbol	</Table.HeaderCell>
											 <Table.HeaderCell>Sell Price per Unit</Table.HeaderCell>
											 <Table.HeaderCell>Quantity</Table.HeaderCell>
											 <Table.HeaderCell>Total Sell Amount</Table.HeaderCell>
											 <Table.HeaderCell>Status</Table.HeaderCell>
										 </Table.Row>
									 </Table.Header>

									 <Table.Body>
												 {list.length==0&&<Table.Row negative><Table.Cell  colSpan='10' textAlign="center">No record found</Table.Cell></Table.Row>}
												 {list.map(function(data, key){
													 return <Table.Row key={key}>
															 <Table.Cell collapsing>
																 <Button className='red' size='small'  icon='trash alternate outline' onClick={()=>DeleteConfirmation(data.id)} />
															 </Table.Cell>
															 <Table.Cell collapsing>
																 <Button className='primary' size='small' icon='edit' as="a" href={WindowURLAdmin('/tradingsell/'+data.id)}/>
															 </Table.Cell>
															 <Table.Cell>{data.account}</Table.Cell>
															 <Table.Cell>{data.transaction_number}</Table.Cell>
															 <Table.Cell>{data.sell_date}</Table.Cell>
															 <Table.Cell>{data.ticker_symbol}</Table.Cell>
															 <Table.Cell>{data.price_unit}</Table.Cell>
															 <Table.Cell>{data.quantity}</Table.Cell>
															 <Table.Cell>{data.sell_amount}</Table.Cell>
															 <Table.Cell>{data.status}</Table.Cell>
													 </Table.Row>
												 })}
										 </Table.Body>
										 {list.length>0&&
											 <Table.Footer fullWidth>
													 <Table.Row>
													 <Table.HeaderCell colSpan='10'>
															 <div className="dash-footer"><Paginations callbackPagination={paginations} callbackPagenumber={pagenumberfunction}/></div>
													 </Table.HeaderCell>
													 </Table.Row>
											 </Table.Footer>
										 }
								 </Table>
								 </div>
						 </div>
					</div>

      </div>
    </React.Fragment>
  )
}
